"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePlugin = void 0;
class BasePlugin {
    // already selected
    _isAlreadySelected(activity) {
        return activity.registered && activity.disabled === false;
    }
    // can be selected
    _isOpenForSelect(activity) {
        return activity.registered === false && activity.disabled === false;
    }
    // disabled for select
    _isDisabled(activity) {
        return activity.disabled === true;
    }
}
exports.BasePlugin = BasePlugin;
